import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord, getApiOrderRecord } from 'services/InboundDeliveryService'

export const getData = createAsyncThunk('inboundDelivery/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('inboundDelivery/data/getRecord', async id => {
    const headerResponse = await getApiRecord(id)
    const detailResponse = await getApiOrderRecord({ asn_header_id: id })
    const data = {
        ...headerResponse.data,
        order_details: detailResponse.data.results || [],
    }
    return data
})

export const orderDefaultData = {
    'Line Seq': '',
    Sku: '',
    'Ordered Qty': '',
    notes: '',
}

const recordData = {
    company: '',
    site: '',
    client: '',
    shipment: '',
    customer: '',
    order_type: '',
    reference_1: '',
    reference_2: '',
    status: '',
    created_date: '',
    closed_date: '',
    carrier: '',
    carrier_service: '',
    tracking: '',
    line_no: '',
    sku: '',
    qty_ordered: '',
    order_details: [],
    priority: '3',
    warehouse_id: '',
    doc_no: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: 'N',
    orderType: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'inboundDelivery/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
